import * as tslib_1 from "tslib";
import { Api } from './api';
import * as i0 from "@angular/core";
import * as i1 from "./api";
var FilterApi = /** @class */ (function () {
    function FilterApi(api) {
        this.api = api;
    }
    FilterApi.prototype.getSqlStringFromQuery = function (query) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query GetSql($query: QueryInput!) {\n                    sql(query: $query)\n                }\n        ", { query: query }, 'GET', 'sql')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FilterApi.prototype.getSqlStringFromQueryWithLayer = function (query, layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api.http2.graphqlRequest("\n                query GetSql($query: QueryInput!) {\n                    sql(query: $query, layerId: " + layerId + ")\n                }\n        ", { query: query, layerId: layerId }, 'GET', 'sql')];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    FilterApi.ngInjectableDef = i0.defineInjectable({ factory: function FilterApi_Factory() { return new FilterApi(i0.inject(i1.Api)); }, token: FilterApi, providedIn: "root" });
    return FilterApi;
}());
export { FilterApi };
